"use client";
import { usePathname } from 'next/navigation';
import MarketingHeader from './marketing-header';
import SiteHeader from './site-header';

const hiddenPaths = [
  '/admin/login',
  '/preceptor/onboarding',
  '/student/onboarding',
  '/student/np/login',
  '/student/pa/login',
  '/student/img/login',
  '/student/np/signup',
  '/student/pa/signup',
  '/student/img/signup',
  '/preceptor/login',
  '/preceptor/signup',
  '/unauthorized',
];

const portalPrefixes = [
  '/admin/dashboard',
  '/admin/bookings',
  '/admin/discounts',
  '/admin/documents',
  '/admin/installments',
  '/admin/messages',
  '/admin/milestone-payments',
  '/admin/payment-phases',
  '/admin/pending-verification',
  '/admin/placements',
  '/admin/preceptor-applications',
  '/admin/preceptor-profile-requests',
  '/admin/preceptors',
  '/admin/img-preceptors',
  '/admin/img-applications',
  '/admin/img-students',
  '/admin/profile',
  '/admin/settings',
  '/admin/students',
  '/admin/transactions',
  '/admin/universities',
  '/student/dashboard',
  '/student/billing',
  '/student/book-preceptor',
  '/student/bookings',
  '/student/messages',
  '/student/profile',
  '/student/school',
  '/student/settings',
  '/preceptor/dashboard',
  '/preceptor/calendar',
  '/preceptor/bookings',
  '/preceptor/messages',
  '/preceptor/profile',
  '/preceptor/settings',
  '/preceptor/welcome',
  '/staff',
  '/super-admin',
];

function isPortalPage(pathname: string) {
  return portalPrefixes.some(
    (p) => pathname === p || pathname.startsWith(p + '/')
  );
}

export default function RoleAwareHeader() {
  const pathname = usePathname();

  if (hiddenPaths.some((p) => pathname === p || pathname.startsWith(p + '/'))) {
    return null;
  }

  if (isPortalPage(pathname)) {
    return <SiteHeader />;
  }

  // Preceptor rotation search pages render their own desktop header (logo • filters •
  // dashboard), so the marketing nav is shown on mobile only there.
  const isPreceptorSearch =
    pathname.startsWith('/preceptor') && /(^|\/)search(\/|$)/.test(pathname);
  if (isPreceptorSearch) {
    // Mobile only, and non-sticky so it scrolls away while the page's own filter
    // bar pins to the top. Desktop uses the page's custom header instead.
    return (
      <div className="lg:hidden">
        <MarketingHeader sticky={false} />
      </div>
    );
  }

  return <MarketingHeader />;
}
